<template>

<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M38 79.6739C26.2727 74.9268 18 63.4295 18 50C18 45.5647 18.9023 41.3402 20.5334 37.5" stroke="black" stroke-width="4"/>
<path d="M38 91.1111L60.001 80.9185L38 72L38 81.5556L38 91.1111Z" stroke="black" stroke-width="4" stroke-linecap="round"/>
<path d="M60.001 21.4372C71.7283 26.1843 80.001 37.6816 80.001 51.1111C80.001 55.5464 79.0986 59.7709 77.4675 63.6111" stroke="black" stroke-width="4"/>
<path d="M60.001 10L38 20.1926L60.001 29.1111L60.001 19.5556L60.001 10Z" stroke="black" stroke-width="4" stroke-linecap="round"/>
</svg>

</template>
